<template>
  <v-row class="pa-5" v-if="exercise">
    <v-col cols="12">
      <v-row>
        <v-col cols="4">
          <v-card light :color="$t(`${lang}.color-1`)">
            <v-card-text>
              <unit-area-items
                v-model="exercise.doc.matrix.q1"
                name="matrix.q1"
                :title="$t(`${lang}.col1`)"
              ></unit-area-items>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="4">
          <v-card light :color="$t(`${lang}.color-2`)">
            <v-card-text>
              <unit-area-items
                v-model="exercise.doc.matrix.q2"
                name="matrix.q2"
                :title="$t(`${lang}.col2`)"
              ></unit-area-items> </v-card-text
          ></v-card>
        </v-col>
        <v-col cols="4">
          <v-card light :color="$t(`${lang}.color-3`)">
            <v-card-text>
              <unit-area-items
                v-model="exercise.doc.matrix.q3"
                name="matrix.q3"
                :title="$t(`${lang}.col3`)"
              ></unit-area-items> </v-card-text
          ></v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
// import lodash from "lodash";
const fb = require("@/firebaseConfig.js");
import { mapState } from "vuex";
import { UnitAreaItems } from "@/components/units";

export default {
  name: "ResultsStakeholderUser",
  data() {
    return {
      doc: null,
      exercise: null,
      dialog: false,
    };
  },
  props: {
    uid: String,
    id: String,
    model: String,
    lang: String,
  },
  components: {
    UnitAreaItems,
  },
  mounted() {
    this.getExercise();
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  methods: {
    getExercise() {
      console.log("get exercise");
      let ref = fb.stakeholderExCollection
        .where("pid", "==", this.id)
        .where("uid", "==", this.uid);
      ref.onSnapshot((querySnapshot) => {
        let items = [];
        querySnapshot.forEach((docs) => {
          let doc = docs.data();
          items.push(doc);
        });
        this.exercise = items[0];
      });
    },
  },
};
</script>
